import {
  ImageScaleView,
  View,
  ViewOpts,
  animate,
} from '@play-co/timestep-core/ui';
import { SpineView, spineLoader } from '@play-co/timestep-spine';
import { downscale } from 'src/conf/scale';
import { ShineStarsFx } from 'src/game/minigame/match2-timestep/components/ShineStarsFX';

export class SuperLollipopAnimation extends View {
  private container: View;
  private glow: ImageScaleView;
  private lollipop: ImageScaleView;
  private sparkles: ShineStarsFx;

  constructor(opts: ViewOpts) {
    super({
      width: downscale(456),
      height: downscale(456),
      centerOnOrigin: true,
      ...opts,
    });

    this.container = new View({
      superview: this,
      centerOnOrigin: true,
      canHandleEvents: opts.canHandleEvents,
    });

    this.glow = new ImageScaleView({
      superview: this.container,
      image: 'assets/ui/superLollipop/shared/lollipop_glow.png',
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      width: this.style.width + 100,
      height: this.style.height + 100,
      centerOnOrigin: true,
      scaleMethod: 'contain',
      canHandleEvents: opts.canHandleEvents,
    });

    this.lollipop = new ImageScaleView({
      superview: this.container,
      image: 'assets/ui/superLollipop/shared/lollipop.png',
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      width: this.style.width,
      height: this.style.height,
      centerOnOrigin: true,
      scaleMethod: 'contain',
      canHandleEvents: opts.canHandleEvents,
    });

    this.sparkles = new ShineStarsFx({
      superview: this,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      width: 150,
      height: 150,
      centerOnOrigin: true,
      scale: 2,
      canHandleEvents: opts.canHandleEvents,
      emitterConfig: {
        particleCount: 10,
      },
    });

    this.sparkles.play();
    this.on('ViewRemoved', () => this.sparkles.stop());

    void this.playRadialShine();
  }

  public tick(dt: number) {
    this.lollipop.updateOpts({
      r: this.lollipop.style.r + dt * 0.001,
    });

    this.container.updateOpts({
      y: Math.sin(this.lollipop.style.r * 2.5) * 10,
    });

    this.glow.updateOpts({
      scale: 1 + Math.sin(this.lollipop.style.r * 5.3) * 0.1,
    });
  }

  private async playRadialShine() {
    const spinePath = 'assets/ui/superLollipop/animation/shine-and-confetti';
    await spineLoader(spinePath);
    const spine = new SpineView({
      superview: this.container,
      spinePath,
      zIndex: -1,
      x: this.style.width / 2,
      y: this.style.height / 2,
      opacity: 0,
    });
    spine.state.setAnimation(0, 'radial', true);
    animate(spine).now({ opacity: 1 }, 500, animate.linear);
  }
}
